import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Intercom from 'react-intercom';
import Permissions from 'react-redux-permissions';
// routes config
import getRoutes from '../../routes';
import Header from '../header';
import Footer from '../footer';
import CheckPath from '../../components/checkPath';
import Tawk from '../../components/tawk';
import Crisp from '../../components/crisp';
import Customerly from '../../components/customerly';
import ActiveChat from '../../components/activeChat';

const Layout = ({ isLoading, modulesTypes, hasLoadedPage, intercomId, user, defaultRoute }) => (
  <div className="app">
    { !isLoading && (
      <React.Fragment>
        <React.Fragment>
          <main className="main">
            <Header />
            <Switch>
              {getRoutes().map(route =>
                  (route.component && (
                    route.module === undefined ?
                      true : modulesTypes.includes(route.module)) ? (
                        <Route
                          key={route.path}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props2 => (
                            <Permissions
                              allowed={route.permissions}
                              fallbackElement={<Redirect from="*" to={defaultRoute} />}
                            >
                              {(!!user || route.isPublic) && <route.component {...props2} />}
                              {(!user && !route.isPublic) && <Redirect to="/login" />}
                            </Permissions>
                        )}
                        />
                    )
                    : (null)))
                }
              <Redirect from="/modules" to="/modules/index" />
              <Redirect from="/users" to="/users/index" />
              <Route path="/*" render={prop => (<CheckPath {...prop} />)} />
            </Switch>
            {
              !!intercomId &&
                <Intercom
                  appID={intercomId}
                  name={user ? user.username : null}
                  email={user ? user.email : null}
                />
              }
            <Tawk />
            <Crisp />
            <Customerly />
            <ActiveChat />
            {!!hasLoadedPage && <Footer />}
          </main>
        </React.Fragment>
      </React.Fragment>
    )}
  </div>
);

Layout.propTypes = {
  t: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasLoadedPage: PropTypes.bool.isRequired,
};

export default Layout;




// WEBPACK FOOTER //
// ./src/containers/layout/Layout.js